// Real-human check (2026-10-01) -- client half of services/common/human.py.
//
// getHumanToken() opens the <HumanCheckModal> (Cloudflare Turnstile) and
// resolves with a one-time token. Concurrent callers share one challenge.
// ensureHumanPass() exchanges a token for the server's short-lived
// "human pass" cookie. Both are no-ops when no site key is configured
// (local dev without REACT_APP_TURNSTILE_SITE_KEY).
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";
export const HUMAN_CHECK_EVENT = "rp360:human-check";
export const HUMAN_CHECK_REQUIRED = "human_check_required";

let pending = null;

export function getHumanToken() {
  if (!TURNSTILE_SITE_KEY) return Promise.resolve(null);
  if (!pending) {
    pending = new Promise((resolve, reject) => {
      window.dispatchEvent(new CustomEvent(HUMAN_CHECK_EVENT, { detail: { resolve, reject } }));
    }).finally(() => { pending = null; });
  }
  return pending;
}

export async function ensureHumanPass(api, fetchImpl = window.fetch) {
  const token = await getHumanToken();
  if (!token) return false;
  const r = await fetchImpl(`${api}/ai/human-check`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token }),
  });
  if (r.ok) {
    const d = await r.json().catch(() => ({}));
    rememberPass(d.expires_in);
  }
  return r.ok;
}

// Proactive check (2026-10-01: "the checker should come before any AI API
// request"). AuthContext tells us whether someone is signed in; for
// signed-out visitors the fetch wrapper (GlobalUpgradePrompt) runs the
// check BEFORE sending an AI request, instead of after a 403. The pass
// expiry is remembered for this tab (the cookie itself is HttpOnly); the
// 403-then-replay path still covers an expired or cleared cookie.
let signedIn = null; // null = not known yet (auth still loading)
export function setHumanCheckSignedIn(v) { signedIn = v === null ? null : !!v; }
const PASS_KEY = "rp360_human_pass_until";
const AI_PATH = /\/api\/(ai|support\/chat|scrape-job)/;
const UNGATED = /\/api\/ai\/(plans|human-check)(\?|$)/;

export function needsProactiveCheck(url) {
  if (!TURNSTILE_SITE_KEY || signedIn !== false || !AI_PATH.test(url) || UNGATED.test(url)) return false;
  let until = 0;
  try { until = Number(sessionStorage.getItem(PASS_KEY) || 0); } catch {}
  return Date.now() > until;
}

export function rememberPass(expiresInSec) {
  try { sessionStorage.setItem(PASS_KEY, String(Date.now() + Math.max(0, (expiresInSec || 0) - 60) * 1000)); } catch {}
}
